<template>
  <section class="section-shaped my-4 pt-5 bg-secondary" id="elenco_dublagem" v-if="movie.elenco_dublagem.length > 0">
    <div class="container">
      <v-wait for="titulo.ficha.load" transition="fade" :duration="750"> 
        <template slot="waiting">
          <div class="col">
            <div class="ph-col-5 mt-3 mb-5"></div>
            <div class="ph-container">
              <div class="ph-col-7 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-4 mb-2"></div>
              <div class="ph-col-7 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-4 mb-2"></div>
            </div>
          </div>
        </template>
        <div class="col pb-3">
          <h3 class="display-3">Elenco de Dublagem</h3>
            <div class="table-responsive mt-4">
                <table class="table elenco-table">
                  <thead>
                    <tr>
                      <th scope="col" class="table-cell">Ator (Personagem)</th>
                      <th scope="col" class="table-cell" v-for="cast in movie.elenco_dublagem" :key="cast.estudio">{{ cast.estudio }}</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="papel in elenco" :key="papel">
                        <td class="text-dark"><strong>{{ papel }}</strong></td>
                        <td class="text-dark" v-for="cast in movie.elenco_dublagem" :key="cast.estudio" v-text="findDublador(papel,cast.papeis)"></td>
                      </tr>
                  </tbody>
                </table>
            </div>
            <div class="pb-5" v-if="fontes.length > 0">
              <h4 class="display-4">Créditos</h4>
              <base-button size="sm" type="secondary" icon="fa fa-external-link" class="mr-2 mb-2" v-for="parceiro in fontes" :key="parceiro.nome" target="_blank" :href="parceiro.url" tag="a">{{ parceiro.nome }}</base-button>
            </div>
        </div>
      </v-wait>
    </div>
  </section>
</template>
<script>
import BaseButton from '@/components/BaseButton.vue';
export default {
  components: { BaseButton },
  name: 'movieElencoDublagem',
  data() {
    return {
      fontes: [
        {
          nome: 'Humber Sanoj',
          url: 'https://sanojhumber.blogspot.com/',
        },
        {
          nome: 'Wiki Dublagem',
          url: 'https://dublagempedia.fandom.com/pt-br/wiki/Wiki_Dublagem',
        },
        {
          nome: 'Wikipedia Wiki',
          url: 'https://vvikipedia.fandom.com/pt/wiki/P%C3%A1gina_principal',
        },
        {
          nome: 'Casa da Dublagem',
          url: 'http://casadadublagem10.blogspot.com/',
        },
      ]
    }
  },
  computed: {
    movie() {
      return this.$store.state.catalog.movie;
    },
    elenco() {
      let _elenco = [];
      this.movie.elenco_dublagem.forEach(elenco => {
          elenco.papeis.forEach(item => {
              if(_elenco.indexOf(item.papel) == -1) {
                _elenco.push(item.papel);
              }
          });
      });
      return _elenco;
    },
  },
  methods: {
      findDublador(role='',cast=[]) {
        const search = cast.filter(obj => obj.papel == role);
        if(search.length) {
            let dublador_string = (search.length > 1) ? search.map(papel => papel.dublador).join(', ') : search[0].dublador;
            return dublador_string;
        }else{
            return '-';
        }
      }
  }
};
</script>


<style lang="scss" scoped>
.elenco-table {
  font-size: 0.85rem;
}
.table-cell {
  display: table-cell;
  width: 1%;
  font-size: 1rem;
}
</style>